import toast from "react-hot-toast";
import * as api from "../Api";

const failed = (error, fallback) => {
  toast.error(error?.response?.data?.message || fallback);
  throw error;
};

export const createStockLocation = (postData) => async (dispatch) => {
  try {
    const { data } = await api.createLocation(postData);
    dispatch({ type: "CREATE_STOCK_LOCATION", payload: data });
    toast.success(`${data.location} added`);
    return data;
  } catch (error) {
    failed(error, "Couldn't add the location");
  }
};

export const getAllLocation = () => async (dispatch) => {
  try {
    const { data } = await api.getStockLocation();
    dispatch({ type: "STOCK_LOCATION", payload: data });
  } catch (error) {}
};

export const deleteStockLocation = (id) => async (dispatch) => {
  try {
    await api.deleteStockLocation(id);
    dispatch({ type: "DELETE_STOCK_LOCATION", payload: id });
    toast.success("Location deleted");
  } catch (error) {
    failed(error, "Couldn't delete the location");
  }
};

export const updateLocation = (id, postData) => async (dispatch) => {
  try {
    const { data } = await api.updateLocation(id, postData);
    dispatch({ type: "UPDATE_LOCATION", payload: data });
    toast.success("Location saved");
    return data;
  } catch (error) {
    failed(error, "Couldn't save the location");
  }
};
